import React, { createRef } from "react";
import MyAvailabilityChild from "./MyAvailabilityChild";
import api from "utils/api";
import utils from 'utils';
import "./MyAvailability.scss";
import { Button, Col, Row } from "antd";
import { CONSTANTS } from "utils/constant";
const order = { Sunday: 1, Monday: 2, Tuesday: 3, Wednesday: 4, Thursday: 5, Friday: 6, Saturday: 7 };

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            availableDays: undefined,
            holidays: undefined,
            netErr:"",
        }        
        this.queryStringRef = createRef();
        this.doctorIdRef = createRef();
        this.doctorIdRef.current = this.props?.location?.state?.doctor_id || "";
        this.queryStringRef.current = new URLSearchParams({
            doctor_id: this.doctorIdRef.current
            }).toString();
    }
    componentDidMount = () => {
        this.getListAvailability();
        this.getListHolidays();
    }

    getListAvailability() {
        this.setState({ isLoading: true })
        api.myAvailabilty_list(this.queryStringRef.current)
            .then((response) => {
                let { status, message, data } = response.data;
                if (status == 200) {
                    // let sortedObj = data?.results.sort((a, b) => {
                    //     return order[a.day_of_week] - order[b.day_of_week];
                    // });
                    //  conole.log(sortedObj);
                    let finalAvailableData = (data?.results || []).map(obj => {
                        let convertStartTime = utils.FormatDate(obj.start_time, "TIME_1");
                        let convertEndTime = utils.FormatDate(obj.end_time, "TIME_1");
                        convertStartTime = convertStartTime == "12:00 AM" ? "00:00 AM" : convertStartTime;
                        convertEndTime = convertEndTime == "11:59 PM" ? "12:00 AM" : convertEndTime;
                        return {
                            ...obj,
                            left_value: obj.day_of_week,
                            right_value: `${convertStartTime} - ${convertEndTime}`
                        }
                    })
                    this.setState({ availableDays: finalAvailableData, isLoading: false });
                } else utils.Toast({ type: "error", message })
            })
            .catch(error => {
                this.setState({ isLoading: false,netErr:error })

            })
    }

    getListHolidays() {
        this.setState({ isLoading: true })
        api.holidays_list(this.doctorIdRef.current)
            .then((response) => {
                let { status, message, data } = response.data;
                if (status == 200) {
                    let arr1 = data.results.map(obj => {
                        return { ...obj, start_day: new Date(obj.start_day) };
                    });
                    let sortedAsc = arr1.sort(
                        (objA, objB) => Number(objA.start_day) - Number(objB.start_day),
                    );
                    let finalHolidayData = (sortedAsc || []).map(obj => ({
                        ...obj,
                        left_value: `From: ${utils.FormatDate(obj.start_day, "DATE_1")}`,
                        right_value: `To: ${utils.FormatDate(obj.end_day, "DATE_1")}`
                    }))

                    this.setState({ holidays: finalHolidayData, isLoading: false });

                } else utils.Toast({ type: "error", message })
            })
            .catch((error) => {
                this.setState({ isLoading: false, netErr:error})
            })
    }

    handleAvailabilty(col, value) {
        if(this.doctorIdRef.current)
        value.doctor_id=this.doctorIdRef.current;
        if (col == "doctor_availability") {
            api.addEdit_myAvailabilty_list(value)
                .then(response => {
                    let { status, message } = response.data || {};
                    utils.Modal(false);
                    utils.Toast({ type: "success", message: utils.ConvertToPascalCase(message) });
                    this.getListAvailability()
                })
                .catch(error => {
                })
        }
        if (col == "doctor_holiday") {
            api.addEdit_holidays_list(value)
                .then(response => {
                    let { status, message } = response.data || {};
                    utils.Modal(false);
                    utils.Toast({ type: "success", message: utils.ConvertToPascalCase(message) });
                    this.getListHolidays();
                })
                .catch(error => {
                })
        }
    }


    render() {
        if(this.state.netErr!==""){
            throw new Error(this.state.netErr)
        }
        return (<div> {
            <div className="my-availability-container">
                <Row className="main-content">
                    <Col xs={24} className="main-content-top">
                        {/* <Row className="main-content-header">{CONSTANTS.MY_AVAILABILITY}</Row> */}
                        {this.props?.location?.state?.doctor_id && (
                      <div>
                        {" "}
                        <Button
                          className="previous-page-button"
                          onClick={(e) => this.props.history.go(-1)}
                        >
                          {CONSTANTS.BACK_TO_PREVIOUS_PAGE}
                        </Button>                        
                      </div>
                    )}
                    </Col>
                    <Col xs={24}>
                        <Row gutter={[24, 24]}
                        // className="content-body"
                        >
                            <Col xs={24} md={12}>
                                <div className="sub-content-header">{CONSTANTS.AVAILABILITY_SUB_CONTENT_HEADER} {this.props?.location?.state?.name?`(${this.props?.location?.state?.name})`:""}</div>
                                <MyAvailabilityChild
                                    title={CONSTANTS.AVAILABLE_DAYS}
                                    name="doctor_availability"
                                    data={this.state.availableDays}
                                    handleFunction={this.handleAvailabilty.bind(this)} />
                            </Col>
                            <Col xs={24} md={12}>
                                <div className="sub-content-header">{CONSTANTS.AVAILABILITY_SUB_CONTENT_HEADER_1} {this.props?.location?.state?.name?`(${this.props?.location?.state?.name})`:""}</div>
                                <MyAvailabilityChild
                                    title={CONSTANTS.HOLIDAYS}
                                    name="doctor_holiday"
                                    data={this.state.holidays}
                                    handleFunction={this.handleAvailabilty.bind(this)}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        }

        </div>)
    }
}

